.cell {
	composes: body-2 from global;
	overflow: hidden;
	text-overflow: ellipsis;
}
